import { render, staticRenderFns } from "./UnlockSingle.vue?vue&type=template&id=6fcb5fd4&scoped=true&"
import script from "./UnlockSingle.vue?vue&type=script&lang=js&"
export * from "./UnlockSingle.vue?vue&type=script&lang=js&"
import style0 from "./UnlockSingle.vue?vue&type=style&index=0&id=6fcb5fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcb5fd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fcb5fd4')) {
      api.createRecord('6fcb5fd4', component.options)
    } else {
      api.reload('6fcb5fd4', component.options)
    }
    module.hot.accept("./UnlockSingle.vue?vue&type=template&id=6fcb5fd4&scoped=true&", function () {
      api.rerender('6fcb5fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/運勢書2024/UnlockSingle.vue"
export default component.exports